
import React, { useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import LoginUI from '../LoginUI';
import EmailSendUI from '../EmailSendUI';
import MyProfile from '../MyProfile';
import VacanciesMobUI from '../MobUI/VacanciesMobUI';
import VacanciesUI from '../VacanciesUI';
import RecruitmentVacancyPageMobUI from '../MobUI/RecruitmentVacancyPageMobUI';
import RecruitmentVacancyPageUI from '../RecruitmentVacancyPageUI';
import RecruiterRegistrationPageMobUI from '../MobUI/RecruiterRegistrationPageMobUI';
import RecruiterRegistrationPageUI from '../RecruiterRegistrationPageUI';
import TermsandConditions from '../PC/TermsandConditions';
import PrivacyPolicy from '../PC/PrivacyPolicy';
import LoginUIMobile from '../LoginUIMobile';

const PublicRoutes = ({isMobile, showAlert}) => {
  const [alert, setAlert] = useState(null);
    // const showAlert = (message, type) => {
  
    //   setAlert({
    //     msg: message,
    //     type: type
    //   })
    //   setTimeout(() => {
    //     setAlert(null)
    //   }, 3000);
    // }

    return (<Routes>
        <Route path="/dashboard" element={isMobile ? <LoginUIMobile showAlert={showAlert} />
            : <LoginUI showAlert={showAlert} />} />
        <Route path="/forgotpassword" element={<EmailSendUI showAlert={showAlert} />} />
        <Route path="/apply" element={<MyProfile showAlert={showAlert} />} />
        {/* <Route path="/schedule" element={<ScheduleInterview showAlert={showAlert}/>}/> */}

        {/* <Route path="/test" element={<UserPasswordResetUI showAlert={showAlert}/>}/> */}
        <Route path="/vacancies" element={isMobile ? <VacanciesMobUI showAlert={showAlert} /> : <VacanciesUI showAlert={showAlert} />} />
        <Route path="/recruitervacancies" element={isMobile ? <RecruitmentVacancyPageMobUI showAlert={showAlert} /> : <RecruitmentVacancyPageUI showAlert={showAlert} />} />
        <Route path="/recruiterRegistration" element={isMobile ? <RecruiterRegistrationPageMobUI /> : <RecruiterRegistrationPageUI showAlert={showAlert} />} />
        <Route path="/termsandcondition" element={<TermsandConditions showAlert={showAlert} />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy showAlert={showAlert} />} />
        <Route path="*" element={isMobile ? <LoginUIMobile showAlert={showAlert} />
            : <LoginUI showAlert={showAlert} />} />
    </Routes>)

}
export default PublicRoutes